import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CreateEmpresas from "../clientes/Empresas/Create.js"
import moment from 'moment';

import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import ParadigmaEditor from '../../components/ParadigmaEditor/ParadigmaEditor.js';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: "",
            contenido: "",
            tags: "",
            fecha: moment(),
            ficheroAdjunto: "",
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
    }

    getData() {
        const data = new FormData();

        data.append("nombre", this.state.nombre);
        data.append("contenido", this.state.contenido);
        data.append("tags", this.state.tags);
        data.append("fecha", this.state.fecha.format("YYYY-MM-DD"));

        const node = document.getElementById("fileTutorial");
        if (node && node.files.length == 1) {
            data.append("adjunto", node.files[0], node.files[0].name);
        }

        return data;
    }

    setData(data) {
        this.setState({
            nombre: data.nombre,
            contenido: data.contenido,
            tags: data.tags,
            fecha: moment(data.fecha, "YYYY-MM-DD"),
            ficheroAdjunto: data.adjuntos.length > 0 ? data.adjuntos[0] : "",
        });
    }

    resetForm() {
        this.setState({
            nombre: "",
            contenido: "",
            tags: "",
            ficheroAdjunto: "",
            fecha: moment(),
        });
        if (this.props.onClose) this.props.onClose();
    }

    getVars() {
        const { action } = this.props;

        const vars = {
            CREATE: {
                onPreSubmit: () => this.getData(),
                onSubmit: () => this.props.onSubmit(),
                onClose: () => this.resetForm(),
                postUrl: api.tutoriales.create,
                successMessage: "El Tutorial ha sido creado con éxito.",
                title: "Nuevo Tutorial",
                buttonTitle: "Nuevo Tutorial",
                buttonIcon: "fa fa-plus fa-lg",
                saveButton: true,
                closeButton: true,
                disabled: false,
            },
            EDIT: {
                onPreSubmit: () => this.getData(),
                onSubmit: () => this.props.onSubmit(),
                onClose: () => this.resetForm(),
                onGotData: (data) => this.setData(data),
                getUrl: api.tutoriales.edit,
                postUrl: api.tutoriales.edit,
                id: this.props.id,
                successMessage: "El Tutorial ha sido editado con éxito.",
                missingIdMessage: "Debe seleccionar una fila.",
                title: "Editar Tutorial",
                buttonTitle: "Editar Tutorial",
                saveButton: true,
                buttonIcon: "fa fa-pencil fa-lg",
                disabled: false,
                closeButton: true,
            },
            DETAIL: {
                onClose: () => this.resetForm(),
                onGotData: (data) => this.setData(data),
                getUrl: api.tutoriales.detail,
                id: this.props.id,
                successMessage: "",
                missingIdMessage: "Debe seleccionar una fila.",
                title: "Tutorial",
                buttonTitle: "Ver Tutorial",
                buttonIcon: "fa fa-search fa-lg",
                saveButton: false,
                closeButton: true,
                disabled: true,
            },
            DELETE: {
                onSubmit: () => this.props.onSubmit(),
                onGotData: (data) => this.setData(data),
                getUrl: api.tutoriales.delete,
                postUrl: api.tutoriales.delete,
                id: this.props.id,
                successMessage: "El Tutorial ha sido eliminado con éxito.",
                missingIdMessage: "Debe seleccionar una fila.",
                title: "Eliminar Tutorial",
                buttonTitle: "Eliminar Tutorial",
                buttonIcon: "fa fa-trash fa-lg",
                saveButton: true,
                closeButton: true,
                danger: true,
                buttonClass: "btn-danger",
                saveButtonLabel: "Eliminar",
                disabled: true,
            },
        };
        return vars[action];
    }

    render() {
        const modalProps = this.getVars();
        return (
            <ParadigmaModal {...modalProps}>
                <Row className="mt-1">
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input disabled={modalProps.disabled} type="text" name="nombre" value={this.state.nombre} onChange={(evt) => this.setState({ nombre: evt.target.value })}></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row className="my-2">
                    <Col className="col-2">
                        <Label>Fecha</Label>
                    </Col>
                    <Col className="col-4">
                        <Datetime
                            disabled={modalProps.disabled}
                            className="display-inline-block"
                            timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            closeOnSelect={true}
                            // inputProps={{ name: 'fechaContacto' }}
                            value={this.state.fecha}
                            onChange={(e) => this.setState({ fecha: e })}
                        />
                    </Col>
                </Row>
                <Row className="mx-0">
                    <Col className="col-12 p-0">
                        <Label>Contenido</Label>
                    </Col>
                    <Col className="px-0 border">
                        <ParadigmaEditor
                            disabled={modalProps.disabled}
                            value={this.state.contenido}
                            onChange={(contenido) => this.setState({ contenido })}
                        />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className="my-2">
                    {
                        this.state.ficheroAdjunto &&
                        <Col xs={12} className="my-2"><a href={this.state.ficheroAdjunto}><i class="fa fa-download" aria-hidden="true"></i> Descargar fichero adjunto</a></Col>
                    }
                    {
                        !modalProps.disabled &&
                        <React.Fragment>
                            <Col className="col-2 mb-auto">
                                <Label>Adjunto</Label>
                            </Col>
                            <Col className="col-10">
                                <Input disabled={modalProps.disabled} type="file" name="file" id="fileTutorial"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                                <Label>{this.state.ficheroAdjunto && <i className="pl-4">Un nuevo fichero reemplaza al anterior.</i>}</Label>
                            </Col>
                        </React.Fragment>
                    }
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Tutoriales/Modal.js